/**
 * @fileOverview window默认函数实现
 */
import { parseParam } from '../index';
import { handleDomUUID } from '../../index';

export const pageBack = async () => {
  window.history.back();
}

/**
 * 将指定组件滚动到底部
 * @param func
 * @param customParamsList
 * @param customFunctionParams
 * @param instanceId
 */
export const scrollToBottom = async (func, customParamsList, customFunctionParams, instanceId) => {
  if (_size(_get(func, 'inParams')) < 1) {
    return;
  }
  let componentProp = await parseParam(_get(func, 'inParams')[0], customParamsList, customFunctionParams, instanceId);
  // 兼容传入组件对象或 prop 字符串
  const prop = typeof componentProp === 'object' ? _get(componentProp, 'prop') : componentProp;
  if (!prop || typeof prop !== 'string') {
    return;
  }

  const el = document.getElementById(handleDomUUID(prop)) || document.getElementById(prop);
  if (!el) {
    console.warn('scrollToBottom: 未找到组件 DOM 节点', prop);
    return;
  }

  requestAnimationFrame(() => {
    el.scrollTop = el.scrollHeight;
  });
}
